export default "__VITE_ASSET__B_wp7aZX__"